import React, { useState, useEffect } from "react";
import { CDBBtn } from 'cdbreact';
import Select from "react-select";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import { Button } from "react-bootstrap";
import Swal from 'sweetalert2';

export const ModalDispatchOrdersReport = ({
    action,
    setPressedButton,
    formData,
    handleChange,
    providers,
    providerState
  }) => {


    const handleInfoButtonClick = () => {
      Swal.fire({
          title: 'Instrucciones para generar un reporte',
          html:
              '<p style="text-align: justify;">Para generar el reporte, tienes tres filtros disponibles: fecha inicial, fecha final y proveedor. Estos filtros se pueden combinar para realizar búsquedas más específicas. A continuación, se detallan los tipos de búsqueda:</p>' +
              '<ol style="text-align: justify;">' +
              '  <li><strong>Fecha inicial:</strong> Si seleccionas solo la fecha inicial, el sistema mostrará los registros a partir de esa fecha.</li>' +
              '  <li><strong>Fecha final:</strong> Si seleccionas solo la fecha final, el sistema mostrará los registros hasta esa fecha.</li>' +
              '  <li><strong>Entre fecha inicial y final:</strong> Si seleccionas tanto la fecha inicial como la fecha final, el sistema buscará registros dentro de ese rango de fechas.</li>' +
              '  <li><strong>Proveedor:</strong> El sistema mostrará todos los registros del proveedor seleccionado.</li>' +
              '</ol>' +
              '<p style="text-align: justify;"><span style="color: red;">Nota:</span> El sistema seleccionará automáticamente al proveedor, excepto si eres administrador. En ese caso, si no seleccionas ningún proveedor, se mostrarán todos los registros.</p>',
          icon: 'info',
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#146284',
          footer: 'Agradecemos tu colaboración al seguir estos procedimientos para garantizar una generación exitosa del reporte.'
      });
  };   

  const providerSelect = providers.map((provider) => ({
    value: provider.Nit,
    label: `Código Proveedor: ${provider.Nit} / Nombre del proyecto: ${provider.ProjectName}`,
  }));

  return (
    <div className="modal-content">
      <style>
      {`
          .modal-content {
            background-color: #ffffff;
            border-radius: 10px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
          }
          
          .modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px;
            border-bottom: 1px solid #e5e5e5;
          }
          
          .modal-title {
            flex: 1;
            text-align: left;
            font-family: sans-serif;
            font-size: 20px;
            font-weight: bold;
            color: #333333;
          }
          
          .btn-group {
            display: flex;
            justify-content: space-between;
            width: 95%;
            margin-bottom: 15px;
            margin-left: 2.5%;
            margin-top: 2.5%;
          }
          
          .btn-primary {
            background-color: #007bff;
            color: #ffffff;
            border: none;
            border-radius: 5px;
          }
          
          .custom-button {
            background-color: #146284;
          }          
          
          .btn-secondary {
            background-color: #e5e5e5;
            color: #333333;
            border: none;
            border-radius: 5px;
          }
          
          .modal-body {
            padding: 15px;
          }
          
          .modal-footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px;
            border-top: 1px solid #e5e5e5;
          }

          .modal-header .btn-info {
            background-color: #007bff;
            color: #ffffff;
          }
          
          .modal-header .btn-info .fas.fa-info-circle {
            color: #ffffff;
          }
      `}
      </style>
      <div className="modal-header">
        <div className="d-flex justify-content-between align-items-center w-100">
          <h3 className="modal-title">
            {action === 'monthlyReport' ? 'Reporte Ordenes de Despacho' : 'Reporte Ordenes de Despacho'}
          </h3>
          <Button variant="info" onClick={handleInfoButtonClick}>
            <i className="fas fa-info-circle"></i> Información
          </Button>
        </div>
      </div>
      <div className="modal-body">
        <div className="form-group row mb-4">
          <div className="col">
            <label htmlFor="selectedProvider">Seleccione el código del proveedor:</label>
            <Select
              id="selectedProvider"
              isDisabled={String(providerState) !== "1"}
              placeholder="Proveedor"
              options={providerSelect}
              value={providerSelect.find(option => option.value === formData.selectedProvider)}
              onChange={(selectedOption) => {
                handleChange([
                  { id: "selectedProvider", value: selectedOption.value }
                ]);
              }}
            />
          </div>
        </div>
        <div className="form-group row mb-4">
          <div className="col">
              <label htmlFor="selectedInitialDate">Seleccione la fecha inicial:</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  className="form-control mb-4"
                  id="selectedInitialDate"
                  value={dayjs(formData.DeliveryTime)}
                  onChange={(date) => 
                    handleChange([
                      { id: "selectedInitialDate", value: date }
                    ])
                  }
                />
              </LocalizationProvider>
            </div>
            <div className="col">
              <label htmlFor="selectedFinalDate">Seleccione la fecha final:</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                className="form-control mb-4"
                id="selectedFinalDate"
                value={dayjs(formData.DeliveryTime)}
                onChange={(date) =>
                  handleChange([
                    { id: "selectedFinalDate", value: date }
                  ])
                }
              />
              </LocalizationProvider>
            </div>
        </div>
      </div>
      <div className="modal-footer justify-content-center align-items-center">
        <CDBBtn
          type="button"
          color="danger"
          outline
          onClick={() => setPressedButton('closeModal')}
        >
          Cerrar
        </CDBBtn>
        <CDBBtn
          type="button"
          color="primary"
          className="mr-auto"
          outline
          onClick={() => setPressedButton('downloadReport')}
        >
          Descargar
        </CDBBtn>
      </div>
    </div>
  );
};